const compareUserIds = (id1?: number | string, id2?: number | string) => !!id1 && !!id2 && id1 == id2;

export default compareUserIds;
